import { IDealerSettings } from 'pages/Shared/Dealer/Models/dealers';
import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { IOption, Select } from 'components/Select';
import { useTranslation } from 'react-i18next';
import { Switch } from 'components';
import { ACTIVE_DAYS_OPTIONS, NOTIFICATION_OPTIONS } from './constants';

export interface INotificationProps {
  rootDealer: any;
  dealerSettings: IDealerSettings;
  handleChange: (settings: IDealerSettings) => void;
}

export const NotificationsComponent = ({
  rootDealer,
  dealerSettings,
  handleChange,
}: INotificationProps) => {
  const { t } = useTranslation();

  const handleDaysChange = async (option: IOption) => {
    handleChange({
      ...dealerSettings,
      notificationBeforeTicketExpiryInDays: option.value,
    });
  };
  const handleChangeSwitch = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { checked } = e.target;
    handleChange({ ...dealerSettings, notificationOnTicketsExpiry: checked });
  };
  const handleNotificationOptionsChange = async (option: IOption) => {
    handleChange({
      ...dealerSettings,
      notificationOccurrenceForTicketExpiry: option.value,
    });
  };

  return (
    <>
      <Row className="mt-10 align-items-center">
        <Col md={3} />
        <Col md={9}>
          <Switch
            key={`expiryNotification${rootDealer.id}`}
            label={t('dealerManagement.settings.sendNotifications')}
            id={`expiryNotification${rootDealer.id}`}
            onChange={handleChangeSwitch}
            checked={!!dealerSettings?.notificationOnTicketsExpiry}
            className="mb-10 mt-10 div-switch"
          />
        </Col>
      </Row>
      <Row className="mt-10 align-items-center">
        <Col md={3}>
          <h6 className="h6-short">
            {t('dealerManagement.settings.notificationsActiveDays')}
          </h6>
        </Col>
        <Col md={9}>
          <Select
            options={ACTIVE_DAYS_OPTIONS}
            onChange={handleDaysChange}
            value={
              dealerSettings.notificationBeforeTicketExpiryInDays &&
              ACTIVE_DAYS_OPTIONS.find(
                (opt) =>
                  opt.value ===
                  dealerSettings.notificationBeforeTicketExpiryInDays
              )
            }
          />
        </Col>
      </Row>
      <Row className="mt-10 align-items-center">
        <Col md={3}>
          <h6 className="h6-short">
            {t('dealerManagement.settings.notificationsOccurrence')}
          </h6>
        </Col>
        <Col md={9}>
          <Select
            options={NOTIFICATION_OPTIONS}
            onChange={handleNotificationOptionsChange}
            value={
              dealerSettings.notificationOccurrenceForTicketExpiry &&
              NOTIFICATION_OPTIONS.find(
                (opt) =>
                  opt.value ===
                  dealerSettings.notificationOccurrenceForTicketExpiry
              )
            }
          />
        </Col>
      </Row>
    </>
  );
};
